<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ITEM</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- Product Image -->
        <template v-if="dataImg">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="img()" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div>
        </template>

        <!-- NAME -->
        <vs-input label="Name" v-model="dataName" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <!-- CATEGORY -->
        <vs-select v-model="dataCategory" label="Category" class="mt-5 w-full" name="item-category" >
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in category_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>

        <!-- Link -->
        <vs-input label="Link" v-model="dataLink" class="mt-5 w-full" name="item-link" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-link')">{{ errors.first('item-link') }}</span>

        <!-- VERSIUNI -->
        <vs-select v-model="dataVersion" label="Theme Version" class="mt-5 w-full" name="item-v" >
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in versiuni" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-v')">{{ errors.first('item-v') }}</span>

        <!-- VERSIUNI -->
        <vs-textarea v-model="dataContent" class="mt-5 w-full" name="item-content" />
        <span class="text-danger text-sm" v-show="errors.has('item-content')">{{ errors.first('item-content') }}</span>



        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->

        <div class="upload-img mt-5" v-if="!dataImg">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        console.log(this.data);
        let { category, id, img, name, link, v, content } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataCategory = category
        this.dataImg = img
        this.dataName = name
        this.dataVersion = v
        this.dataContent = content
        this.dataLink = link
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.version, this.dataStat } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {

      dataId: null,
      dataName: "",
      dataCategory: [],
      dataImg: null,
      dataVersion: null,
      dataLink: null,
      dataContent: null,

      category_choices: [
        {text:'Hero',value:'hero'},
        {text:'About',value:'about'},
        {text:'Contact',value:'contact'},
        {text:'Features',value:'features'},
        {text:'Agency',value:'agency'},
        {text:'Event',value:'event'}
      ],

      versiuni: [
        {text:'1.0.0',value:'{"theme":"1.0.0","plugins":{ "elementor":"2.8.2"}}'},
        {text:'1.1.0',value:'{"theme":"1.1.0","plugins":{ "elementor":"3.8.2"}}'}
      ],
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataName && this.dataCategory
    }
  },
  methods: {
    img(){
      if(this.dataImg.endsWith(".jpg"))
        return 'https://api.uicore.co/media/' + this.dataImg;
      else
        return this.dataImg;
    },
    initValues() {
      if(this.data.id) return
        this.dataId = null
        this.dataName = ""
        this.dataCategory = null
        this.dataVersion = '{"theme":"1.0.0","plugins":{ "elementor":"2.8.2"}}'
        this.dataImg = null
        this.dataLink = null
        this.dataContent = null
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          if (result) {
            var msg = {}
            const obj = {
              id: this.dataId,
              name: this.dataName,
              img: this.dataImg,
              category: this.dataCategory,
              link: this.dataLink,
              v: this.dataVersion,
              content: this.dataContent,
            }
            console.log(obj);

            if(this.dataId !== null && this.dataId >= 0) {
              this.$store.dispatch("blocksList/updateItem", obj).catch(err => { console.error(err) })
              msg = {
                title:'Done',
                text:'Demo '+this.dataName+' was succesfuly Updates!',
                color:'succes'
              }
            }else{
              delete obj.id
              this.$store.dispatch("blocksList/addItem", obj).catch(err => { console.error(err) })
              msg = {
                title:'Done',
                text:'Demo '+this.dataName+' was succesfuly added!',
                color:'succes'
              }
            }

            this.$emit('notify', msg)   
            this.$emit('closeSidebar')
            this.initValues()
          }
      })
    },
    
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  components: {
    VuePerfectScrollbar,
  },
  mounted(){
    console.log(this.data)
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 450px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
